import { productLines } from '@/plugins/productLines'

export const faqs = {
    LoopCAD: [
        {
            category: 'Requirements',
            question: 'What are the system requirements to run LoopCAD?',
            answer: productLines.LoopCAD.sysReq,
            sortOrder: 1,
        },
        {
            category: 'Requirements',
            question: 'Can I use LoopCAD on a MAC computer?',
            answer: '<p>LoopCAD is a Windows program only and is not Mac compatible. We do have users running LoopCAD on a Mac using a Windows emulation software. They say it works fine, but we have done no testing on this and we do not formally support it.</p>' +
                '<p>You are welcome to test the free trial version to see if it will work on your configuration, however we would not be able to offer technical support for this.</p>',
            sortOrder: 2,
        },
        {
            category: 'Requirements',
            question: 'Do I need AutoCAD to run LoopCAD?',
            answer: '<p>No. AutoCAD is not required to run LoopCAD. LoopCAD is able to import AutoCAD 2016 (and earlier) drawing files for use as a template for your plumbing system design, and it can also export to the DWG and DXF file formats.</p>',
            sortOrder: 3,
        },
        {
            category: 'Requirements',
            question: 'Do I need HeatCAD if I already have LoopCAD?',
            answer: '<p>The Professional and MJ8 Editions of LoopCAD include all of the functionality of the corresponding HeatCAD editions, so you would not normally need both software packages. However, the Standard Edition of LoopCAD does not include the automated heat loss calculations.</p>',
            sortOrder: 4,
        },
        {
            category: 'License and Subscription',
            question: 'Will LoopCAD stop working after the subscription expires?',
            answer: '<p>No. LoopCAD will remain fully functional after the subscription expires, but you will no longer have access to upgrades or all of the support options. See the <a href="/Product/LoopCAD/#licenseInfo">License and Subscriptions</a> page for more information.</p>',
            sortOrder: 5,
        },
        {
            category: 'License and Subscription',
            question: 'What if I let my subscription expire and then later want to upgrade to a newer version of LoopCAD?',
            answer: '<p>If you choose not to renew your annual subscription and then later want to upgrade to a newer version of LoopCAD, you can either:</p>' +
                '<ol type="a"><li>renew your subscription and pay the reinstatement fee, or</li><li>you can simply purchase a new LoopCAD Full license.</li></ol>' +
                '<p>You can choose the option that is least costly for you, which will depend on how long it has been since your subscription expired. The online subscription renewal process will calculate and display the reinstatement and renewal fees.</p>',
            sortOrder: 6,
        },
        {
            category: 'License and Subscription',
            question: 'Do I need to purchase 2 licenses to use LoopCAD on my home and work computers?',
            answer: '<p>The LoopCAD license permits one primary-use installation(for example, your office computer) and one secondary-use installation (for example, on a home or notebook computer), provided that they are both for your use only.If you want a secondary-use activation, follow the instructions by <a href="Help/Secondary-Activation" target="_Blank">clicking here.</a></p>' +
                '<p>If the second installation is for a different user, then an additional license must be purchased.</p>',
            sortOrder: 7,
        },
        {
            category: 'License and Subscription',
            question: 'If I install LoopCAD ' + productLines.LoopCAD.year + ', will I still be able to use my earlier version of LoopCAD?',
            answer: ' <p>Yes. You can install LoopCAD ' + productLines.LoopCAD.year + ' trial without affecting your older LoopCAD installation. The different versions can be used on the same computer at the same time.</p>',
            sortOrder: 8,
        },
        {
            category: 'License and Subscription',
            question: 'If I change computers will my existing activation code still work?',
            answer: '<p>No it will not. You will need to request a new activation code for the new computer.</p>' +
                '<p><a href="Help/Reactivate">Click here for instructions...</a></p>',
            sortOrder: 9,
        },
        {
            category: 'License and Subscription',
            question: 'Is there a Network or Multi-user license available for LoopCAD?',
            answer: '<p>No there is not. LoopCAD requires a local installation and activation for each user.</p><p>LoopCAD is licensed on a per-user basis, but there are discounts available for multiple license purchases (see <a href="../Store?productLine=loopcad">Pricing</a>)</p>',
            sortOrder: 10,
        },
        {
            category: 'Activation and Upgrading Help',
            question: 'I have my Activation Code. How do I enter it?',
            answer: '<p><a href="Help/Enter-Activation">Click here for instructions...</a></p>',
            sortOrder: 11,
        },
        {
            category: 'Activation and Upgrading Help',
            question: 'My Activation Code didn\'t work. What do I do now ?',
            answer: '<p><a href="Help/Troubleshoot">Click here for instructions...</a></p>',
            sortOrder: 12,
        },
        {
            category: 'Activation and Upgrading Help',
            question: 'I want to purchase and activate a new license.',
            answer: '<p><a href="Help/Purchase-CC">Click here for instructions to purchase using a Credit Card...</a></p><p><a href="Help/Purchase-Prepaid">Click here for instructions to purchase using a Prepaid Code...</a></p>',
            sortOrder: 13,
        },
        {
            category: 'Activation and Upgrading Help',
            question: 'How do I renew my Annual Subscription?',
            answer: '<p><a href="Help/Renew-CC">Click here for instructions to renew your subscription using a Credit Card...</a></p><p><a href="Help/Renew-Prepaid">Click here for instructions to renew your subscription using a Prepaid Code...</a></p>',
            sortOrder: 14,
        },
        {
            category: 'Activation and Upgrading Help',
            question: 'How do I upgrade to the latest software version?',
            answer: '<p><a href="Help/Upgrade">If your subscription is active, click here for instructions...</a></p><p><a href="Help/Renew-CC">If your subscription has expired, click here for instructions on renewal...</a></p>',
            sortOrder: 15,
        },
        {
            category: 'Activation and Upgrading Help',
            question: 'I want to activate the software on a second computer for my personal use.',
            answer: '<p><a href="Help/Secondary-Activation">Click here for instructions...</a></p>',
            sortOrder: 16,
        },
        {
            category: 'Activation and Upgrading Help',
            question: 'I have a new computer. How do I transfer my activation?',
            answer: '<p><a href="Help/Reactivate">Click here for instructions...</a></p>',
            sortOrder: 17,
        },
        {
            category: 'Activation and Upgrading Help',
            question: 'Can I transfer one of our licenses to a new or different employee?',
            answer: '<p>Yes you can. You will need to <a href="../Contact">Contact Us</a> to request a transfer.</p>',
            sortOrder: 18,
        },
        {
            category: 'Features and Other Questions',
            question: 'What learning resources are available?',
            answer: ' <p>To get started learning, we recommend using the video tutorials. This gives you 22 video lessons ranging from 2 minutes to 12 minutes each.</p>' +
                '<p><ul><a href="/Support/Tutorial?productLine=loopcad">www.LoopCAD.com/Tutorial</a></ul></p>' +
                '<p>If you want more in-depth help on specific topics you can also download past webinars that we have hosted. These are typically 1-hour long videos.</p>' +
                '<p><ul><a href="/Support/Webinars?productLine=loopcad">Online Webinars</a></ul></p>' +
                '<p>As well LoopCAD provides a comprehensive Help file. From anywhere in the program you can press F1 to open the Help file, or choose the "Help | Contents" menu. You can then browse topics, or search the index for keywords.</p>',
            sortOrder: 19,
        },
        {
            category: 'Features and Other Questions',
            question: 'Can I import PDF drawings?',
            answer: '<p>Yes you can import PDF drawings or scanned drawings in JPG, PNG, or BMP formats as well as AutoCAD DWG and DXF files.</p>',
            sortOrder: 20,
        },
        {
            category: 'Features and Other Questions',
            question: 'Can I calculate heat losses using LoopCAD?',
            answer: '<p>Yes.</p><p>The Professional Edition allows you to calculate residential heating loads using ASHRAE, and residential heating and cooling loads using CSA-F280 R2017.</p>' +
                '<p>The MJ8 Edition adds the Manual J heating and cooling load calculations.</p>' +
                '<p>The Standard Edition does not calculate any of the loads, but you can input the heatings loads manually, and still have hydronic calculations performed.</p>' +
                '<p>Refer to the <a href="https://www.avenir-online.com/AvenirWeb/Pdfs/LoopCAD%20Features.pdf" target="_blank">Feature Comparison Chart</a> for more.</p>',
            sortOrder: 21,
        },
        {
            category: 'Features and Other Questions',
            question: 'Can I calculate cooling loads (heat gain) using LoopCAD?',
            answer: '<p>Yes.</p><p>The Professional Edition allows you to calculate residential heating and cooling loads using CSA-F280 R2017. However cooling load calculations are not available when using ASHRAE.</p>' +
                '<p>The MJ8 Edition adds the Manual J heating and cooling load calculations.</p>' +
                '<p>The Standard Edition does not calculate any of the loads, but you can input the heating loads manually, and still have hydronic calculations performed.</p>' +
                '<p>Refer to the <a href="https://www.avenir-online.com/AvenirWeb/Pdfs/LoopCAD%20Features.pdf" target="_blank">Feature Comparison Chart</a> for more.</p>',
            sortOrder: 22,
        },
        {
            category: 'Features and Other Questions',
            question: 'I don\'t need load calculation. What edition of LoopCAD do I need?',
            answer: '<p>If you do not need LoopCAD to calculate the heating or cooling loads you can purchase the Standard Edition. This is the most economical license option(see <a href = "../Store?productLine=loopcad"> Pricing</a>). It allows you to input the heating loads manually, and still have the hydronic calculations performed.</p>' +
                '<p>Refer to the <a href="https://www.avenir-online.com/AvenirWeb/Pdfs/LoopCAD%20Features.pdf" target="_blank">Feature Comparison Chart</a> for more.</p>',
            sortOrder: 23,
        },
        {
            category: 'Features and Other Questions',
            question: 'What if I don\'t want to draw the detailed circuit (or loops) just yet?',
            answer: '<p>LoopCAD provides the "Quick Design Mode" which can reduce your design time by 50% or more for projects that do not require a detailed circuit layout. In Quick Design Mode the detailed circuit layout is replaced by assigning rooms to manifolds and editing the circuit properties as needed. Later if needed you can always convert the Quick Design project to a Full Design project, and then add the detailed circuit design.</p>' +
                '<p>Search the Help file for "Quick Design" for more information.</p>',
            sortOrder: 24,
        },
        {
            category: 'Features and Other Questions',
            question: 'What is "Spreadsheet Mode" and which editions of LoopCAD include it?',
            answer: ' <p>The Spreadsheet Design Mode is available with select OEM editions only, and provides you with the ability to complete basic radiant heating and snow melt system designs, and materials lists and quotations, without using a drawing. This design mode also stays active even after the LoopCAD trial expires, so you can continue to design systems for as long as the OEM makes this tool available to you.</p>' +
                '<p>Contact specific manufacturers to inquire about the availability of the Spreadsheet Mode in their edition of LoopCAD.</p>' +
                '<p>Search the Help file for "Spreadsheet Mode" for more information.</p>',
            sortOrder: 25,
        },
        {
            category: 'Features and Other Questions',
            question: 'Can I draw counterflow or reverse-return circuits in LoopCAD?',
            answer: '<p>Yes, starting with LoopCAD 2017 counterflow circuit patterns can be generated automatically, and you can still draw them in Freehand mode for those difficult room shapes. View Tutorial "Counterflow Circuits" at <a href="/Support/Tutorial?productLine=loopcad">www.LoopCAD.com/Tutorial</a> for further details.</p>',
            sortOrder: 26,
        },
        {
            category: 'Features and Other Questions',
            question: 'Can I connect circuits from one floorplan to a manifold on a different floorplan?',
            answer: '<p>Currently there is no direct way to connect to a manifold on a different floorplan (or level), but there is the following workaround. These instructions assume you want to connect circuits on an upper floorplan to a manifold on a lower level, but the reverse can be done as well.</p>' +
                '<ol><li>Place a manifold on the upper floor, approximately matching the location where you would want it on the lower floorplan.</li>' +
                '<li>Connect the circuit(s) to this manifold.</li>' +
                '<li>Right-click on this manifold and choose "Manifold Properties".</li>' +
                '<li>Edit the "Height Above Floor" to be a negative height, typically between -8\' to -12\' in order to vertically position the manifold correctly. This is important so that the circuit lengths and head losses are accurate.</li>' +
                '<li>Add a note with a leader pointing to the manifold something like: <span class="inline-note">Circuits are connected to the manifold in the lower level.</span></li>' +
                '<li>If you are generating a materials list you will need to manually edit it to adjust the manifold parts as needed.</li></ol>',
            sortOrder: 27,
        },
        {
            category: 'Features and Other Questions',
            question: 'I am getting an error. How can I send you the details?',
            answer: '<p>If a program error window appears onscreen, first complete the "Name", "Email", and "Notes" fields and then click the "Send Error Report" button. If prompted to include a copy of the project file, choose "Yes".</p>' +
                '<p>It is often helpful if you enter a brief description into the "Notes" field explaining what you were doing or attempting when the error occurred.</p>' +
                '<p>We will review the error details and then contact you.</p>',
            sortOrder: 28,
        },
        {
            category: 'Features and Other Questions',
            question: 'Why are there no Canadian locations available for snow melt load data?',
            answer: ' <p>The snow melt load calculations in LoopCAD are based on ASHRAE (2011 ASHRAE Handbook - HVAC Applications, Chapter 51, Table 1). These calculations and data are only available for a subset of the US locations, and not for any Canadian locations.</p>' +
                '<p>You can read more on this in the Help file - see the "Calculation Methods and Assumptions" and "Snow Melt Loads" topics.</p><p>For Canadian locations we recommend to either:</p>' +
                '<ol class="listAlphabetic faqIndentedList">' +
                '<li>Use the manual load input mode and enter your design load (per unit area); or</li>' +
                '<li>Select a US city with similar climate and snowfall characteristics.</li></ol>',
            sortOrder: 29,
        },
        {
            category: 'Features and Other Questions',
            question: 'Can I specify wall or ceiling radiant heating in LoopCAD?',
            answer: '<p>LoopCAD does not provide a way to directly add radiant wall or ceiling heat to the drawing. It will however automatically calculate the supplemental heat required for a room and this can be supplied by wall or ceiling heat if desired. You can also edit the amount of supplemental heat supplied if you want to lower the floor temperatures further.</p>',
            sortOrder: 30,
        },
        {
            category: 'Features and Other Questions',
            question: 'Can I specify different wall thicknesses?',
            answer: ' <p>Currently there can only be one wall thickness setting per floorplan. We normally recommend that you set this to match the interior wall thickness.You can then draw the exterior walls so that the interior edge approximately lines up with the actual interior edge.</p>' +
                '<p>The reduced wall thickness for the exterior walls will not affect the heat loss calculations because this thickness is for the drawing display only. The heat loss/gain calculations use the construction settings for the wall. So even if the drawing display shows a 4" thick wall, but the construction settings specify an 8" thick wall, the calculations are based on the 8" thick wall.</p>',
            sortOrder: 31,
        },
        {
            category: 'Features and Other Questions',
            question: 'Can I model a Walkout Basement in LoopCAD?',
            answer: ' <p>Yes. See the "Walkout Basements" topic in the Help file within LoopCAD for details.</p>',
            sortOrder: 32,
        },
        {
            category: 'Features and Other Questions',
            question: 'Can I model Vaulted or Cathedral Ceiling in LoopCAD?',
            answer: '<p>Yes. See the "Vaulted or Cathedral Ceilings" topic in the Help file within LoopCAD for details.</p>',
            sortOrder: 33,
        },
    ],
    HeatCAD: [
        {
            category: 'Requirements',
            question: 'What are the system requirements to run HeatCAD?',
            answer: productLines.HeatCAD.sysReq,
            sortOrder: 1,
        },
        {
            category: 'Requirements',
            question: 'Can I use HeatCAD on a MAC computer?',
            answer: '<p>HeatCAD is a Windows program only and is not Mac compatible. We do have users running HeatCAD on a Mac using a Windows emulation software. They say it works fine, but we have done no testing on this and we do not formally support it.</p>' +
                '<p>You are welcome to test the free trial version to see if it will work on your configuration, however we would not be able to offer technical support for this.</p>',
            sortOrder: 2,
        },
        {
            category: 'Requirements',
            question: 'Do I need AutoCAD to run HeatCAD?',
            answer: '<p>No. AutoCAD is not required to run HeatCAD. HeatCAD is able to import AutoCAD 2016 (and earlier) drawing files for use as a template for your plumbing system design, and it can also export to the DWG and DXF file formats.</p>',
            sortOrder: 3,
        },
        {
            category: 'License and Subscription',
            question: 'Will HeatCAD stop working after the subscription expires?',
            answer: '<p>No. HeatCAD will remain fully functional after the subscription expires, but you will no longer have access to upgrades or all of the support options. See the <a href="/Product/HeatCAD/#licenseInfo">License and Subscriptions</a> page for more information.</p>',
            sortOrder: 4,
        },
        {
            category: 'License and Subscription',
            question: 'What if I let my subscription expire and then later want to upgrade to a newer version of HeatCAD?',
            answer: '<p>If you choose not to renew your annual subscription and then later want to upgrade to a newer version of HeatCAD, you can either:</p>' +
                '<ol type="a"><li>renew your subscription and pay the reinstatement fee, or</li><li>you can simply purchase a new HeatCAD Full license.</li></ol>' +
                '<p>You can choose the option that is least costly for you, which will depend on how long it has been since your subscription expired. The online subscription renewal process will calculate and display the reinstatement and renewal fees.</p>',
            sortOrder: 5,
        },
        {
            category: 'License and Subscription',
            question: 'Do I need to purchase 2 licenses to use HeatCAD on my home and work computers?',
            answer: '<p>The HeatCAD license permits one primary-use installation (for example, your office computer) and one secondary-use installation (for example, on a home or notebook computer), provided that they are both for your use only. If you want a secondary-use activation, follow the instructions by <a href="Help/Secondary-Activation">clicking here.</a></p>' +
                '<p>If the second installation is for a different user, then an additional license must be purchased.</p>',
            sortOrder: 6,
        },
        {
            category: 'License and Subscription',
            question: 'If I install HeatCAD ' + productLines.HeatCAD.year + ', will I still be able to use my earlier version of HeatCAD?',
            answer: '<p>Yes. You can install HeatCAD ' + productLines.HeatCAD.year + ' trial without affecting your older HeatCAD installation. The different versions can be used on the same computer at the same time.</p>',
            sortOrder: 7,
        },
        {
            category: 'License and Subscription',
            question: 'If I change computers will my existing activation code still work?',
            answer: '<p>No it will not. You will need to request a new activation code for the new computer.</p>' +
                '<p><a href="Help/Reactivate">Click here for instructions...</a></p>',
            sortOrder: 8,
        },
        {
            category: 'License and Subscription',
            question: 'Is there a Network or Multi-user license available for HeatCAD?',
            answer: '<p>No there is not. HeatCAD requires a local installation and activation for each user.</p>' +
                '<p>HeatCAD is licensed on a per-user basis, but there are discounts available for multiple license purchases (see <a href="../Store?productLine=heatcad">Pricing</a>)</p>',
            sortOrder: 9,
        },
        {
            category: 'Activation and Upgrading Help',
            question: 'I have my Activation Code. How do I enter it?',
            answer: '<p><a href="Help/Enter-Activation">Click here for instructions...</a></p>',
            sortOrder: 10,
        },
        {
            category: 'Activation and Upgrading Help',
            question: 'My Activation Code didn\'t work. What do I do now?',
            answer: '<p><a href="Help/Troubleshoot">Click here for instructions...</a></p>',
            sortOrder: 11,
        },
        {
            category: 'Activation and Upgrading Help',
            question: 'I want to purchase and activate a new license.',
            answer: '<p><a href="Help/Purchase-CC">Click here for instructions to purchase using a Credit Card...</a></p><p><a href="Help/Purchase-Prepaid">Click here for instructions to purchase using a Prepaid Code...</a></p>',
            sortOrder: 12,
        },
        {
            category: 'Activation and Upgrading Help',
            question: 'How do I renew my Annual Subscription?',
            answer: '<p><a href="Help/Renew-CC">Click here for instructions to renew your subscription using a Credit Card...</a></p><p><a href="Help/Renew-Prepaid">Click here for instructions to renew your subscription using a Prepaid Code...</a></p>',
            sortOrder: 13,
        },
        {
            category: 'Activation and Upgrading Help',
            question: 'How do I upgrade to the latest software version?',
            answer: '<p><a href="Help/Upgrade">If your subscription is active, click here for instructions...</a></p><p><a href="Help/Renew-CC">If your subscription has expired, click here for instructions on renewal...</a></p>',
            sortOrder: 14,
        },
        {
            category: 'Activation and Upgrading Help',
            question: 'I want to activate the software on a second computer for my personal use.',
            answer: '<p><a href="Help/Secondary-Activation">Click here for instructions...</a></p>',
            sortOrder: 15,
        },
        {
            category: 'Activation and Upgrading Help',
            question: 'I have a new computer. How do I transfer my activation?',
            answer: '<p><a href="Help/Reactivate">Click here for instructions...</a></p>',
            sortOrder: 16,
        },
        {
            category: 'Activation and Upgrading Help',
            question: 'Can I transfer one of our licenses to a new/different employee?',
            answer: '<p>Yes you can. You will need to <a href="../Contact">Contact Us</a> to request a transfer.</p>',
            sortOrder: 17,
        },
        {
            category: 'Features and Other Questions',
            question: 'What learning resources are available?',
            answer: '<p>The HeatCAD tutorials are under development. Since much of the functionality is the same, it is recommended that you use the LoopCAD tutorials at this time. Specifically lessons 2, 3, 9, 10, 11, 12, 13, 18, 19, 20 and 21.</p>' +
                '<p><a href="/Support/Tutorial?productLine=loopcad">www.LoopCAD.com/Tutorial</a></p>' +
                '<p>If you want more in-depth help on specific topics you can also download past webinars that we have hosted. These are typically 1-hour long videos.</p>' +
                '<p><a href="/Support/Webinars?productLine=heatcad">Online Webinars</a></p>' +
                '<p>As well HeatCAD provides a comprehensive Help file. From anywhere in the program you can press F1 to open the Help file, or choose the "Help | Contents" menu. You can then browse topics, or search the index for keywords.</p>',
            sortOrder: 18,
        },
        {
            category: 'Features and Other Questions',
            question: 'Can I import PDF drawings?',
            answer: '<p>Yes you can import PDF drawings or scanned drawings in JPG, PNG, or BMP formats as well as AutoCAD DWG and DXF files.</p>',
            sortOrder: 19,
        },
        {
            category: 'Features and Other Questions',
            question: 'Can I calculate heat losses using HeatCAD?',
            answer: '<p>Yes.</p><p> The Standard Edition allows you to calculate residential heating loads using ASHRAE, and residential heating and cooling loads using CSA-F280 R2017.</p>' +
                '<p>The MJ8 Edition adds the Manual J heating and cooling load calculations.</p>' +
                '<p>Refer to the <a href="https://www.avenir-online.com/AvenirWeb/Pdfs/HeatCAD%20Features.pdf" target="_blank">Feature Comparison Chart</a> for more.</p>',
            sortOrder: 20,
        },
        {
            category: 'Features and Other Questions',
            question: 'Can I calculate cooling loads (heat gain) using HeatCAD?',
            answer: '<p>Yes.</p><p> The Standard Edition allows you to calculate residential heating and cooling loads using CSA-F280 R2017. However cooling load calculations are not available when using ASHRAE.</p>' +
                '<p>The MJ8 Edition adds the Manual J heating and cooling load calculations.</p>' +
                '<p>Refer to the <a href="https://www.avenir-online.com/AvenirWeb/Pdfs/HeatCAD%20Features.pdf" target="_blank">Feature Comparison Chart</a> for more.</p>',
            sortOrder: 21,
        },
        {
            category: 'Features and Other Questions',
            question: 'I am getting an error. How can I send you the details?',
            answer: '<p>If a program error window appears onscreen, first complete the "Name", "Email", and "Notes" fields and then click the "Send Error Report" button. If prompted to include a copy of the project file, choose "Yes".</p>' +
                '<p>It is often helpful if you enter a brief description into the "Notes" field explaining what you were doing or attempting when the error occurred.</p>' +
                '<p>We will review the error details and then contact you.</p>',
            sortOrder: 22,
        },
        {
            category: 'Features and Other Questions',
            question: 'Why are there no Canadian location available for snow melt load data?',
            answer: '<p>The snow melt load calculations in HeatCAD are based on ASHRAE (2011 ASHRAE Handbook - HVAC Applications, Chapter 51, Table 1). These calculations and data are only available for a subset of the US locations, and not for any Canadian locations.</p>' +
                '<p>You can read more on this in the Help file - see the "Calculation Methods and Assumptions" and "Snow Melt Loads" topics.</p>' +
                '<p>For Canadian locations we recommend to either:</p>' +
                '<ol><li>Use the manual load input mode and enter your design load (per unit area); or</li> <li>Select a US city with similar climate and snowfall characteristics.</li></ol>',
            sortOrder: 23,
        },
        {
            category: 'Features and Other Questions',
            question: 'Can I specify wall or ceiling radiant heating in HeatCAD?',
            answer: '<p>HeatCAD does not provide a way to directly add radiant wall or ceiling heat to the drawing. It will however automatically calculate the supplemental heat required for a room and this can be supplied by wall or ceiling heat if desired. You can also edit the amount of supplemental heat supplied if you want to lower the floor temperatures further.</p>',
            sortOrder: 24,
        },
        {
            category: 'Features and Other Questions',
            question: 'Can I specify different wall thicknesses?',
            answer: '<p>Currently there can only be one wall thickness setting per floorplan. We normally recommend that you set this to match the interior wall thickness.You can then draw the exterior walls so that the interior edge approximately lines up with the actual interior edge.</p>' +
                '<p>The reduced wall thickness for the exterior walls will not affect the heat loss calculations because this thickness is for the drawing display only. The heat loss/gain calculations use the construction settings for the wall. So even if the drawing display shows a 4" thick wall, but the construction settings specify an 8" thick wall, the calculations are based on the 8" thick wall.</p>',
            sortOrder: 25,
        },
        {
            category: 'Features and Other Questions',
            question: 'Can I model a Walkout Basement in HeatCAD?',
            answer: '<p>Yes. See the "Walkout Basements" topic in the Help file within HeatCAD for details.</p>',
            sortOrder: 26,
        },
        {
            category: 'Features and Other Questions',
            question: 'Can I model Vaulted or Cathedral Ceiling in HeatCAD?',
            answer: '<p>Yes. See the "Vaulted or Cathedral Ceilings" topic in the Help file within HeatCAD for details.</p>',
            sortOrder: 27,
        },
    ],
    PlumbingCAD: [
        {
            category: 'Requirements',
            question: 'What are the system requirements to run PlumbingCAD?',
            answer: productLines.PlumbingCAD.sysReq,
            sortOrder: 1,
        },
        {
            category: 'Requirements',
            question: 'Can I use PlumbingCAD on a MAC computer?',
            answer: ' <p>PlumbingCAD is a Windows program only and is not Mac compatible. We do have users running LoopCAD on a Mac computers using a Windows emulation software. They say it works fine, but we have done no testing on this and we do not formally support it.</p>' +
                '<p>You are welcome to test the free trial version to see if it will work on your configuration, however we would not be able to offer technical support for this.</p>',
            sortOrder: 2,
        },
        {
            category: 'Requirements',
            question: 'Do I need AutoCAD to run PlumbingCAD?',
            answer: '<p>No. AutoCAD is not required to run PlumbingCAD, but it is able to import AutoCAD 2019 (and earlier) drawing files for use as a template for your plumbing system design, and it can also export to the DWG and DXF file formats.</p>',
            sortOrder: 3,
        },
        {
            category: 'License and Subscription',
            question: 'Will PlumbingCAD stop working after the subscription expires?',
            answer: '<p>Yes. PlumbingCAD will stop working after the subscription expires. (This is different than LoopCAD and HeatCAD.)</p>' +
                '<p>See the <a href="/Product/PlumbingCAD/#licenseInfo">License and Subscriptions</a> page for more information.</p>',
            sortOrder: 4,
        },
        {
            category: 'License and Subscription',
            question: 'What if I let my subscription expire and then later want to upgrade to renew it?',
            answer: ' <p>If you choose not to renew your annual subscription and then later want to upgrade to a newer version of PlumbingCAD, you can either renew the subscription or purchase a new license. Both options will give you a new 12-month subscription starting on the date you make the purchase.</p>',
            sortOrder: 5,
        },
        {
            category: 'License and Subscription',
            question: 'Do I need to purchase 2 licenses to use PlumbingCAD on my home and work computers?',
            answer: '<p>The PlumbingCAD license permits one primary-use installation (for example, your office computer) and one secondary-use installation (for example, on a home or notebook computer), provided that they are both for your use only. If you want a secondary-use activation, follow the instructions by <a href="Help/Secondary-Activation">clicking here</a></p>' +
                '<p> If the second installation is for a different user, then an additional license must be purchased.</p>',
            sortOrder: 6,
        },
        {
            category: 'License and Subscription',
            question: 'If I change computers will my existing activation code still work?',
            answer: '<p>No it will not. You will need to request a new activation code for the new computer.</p><p><a href="Help/Reactivate">Click here for instructions...</a></p>',
            sortOrder: 7,
        },
        {
            category: 'License and Subscription',
            question: 'Is there a Network or Multi-user license available for PlumbingCAD?',
            answer: ' <p>No there is not. PlumbingCAD requires a local installation and activation for each user.</p><p>PlumbingCAD is licensed on a per-user basis. See the <a href="/Product/PlumbingCAD/#licenseInfo">License and Subscriptions</a> page for more information.</p>',
            sortOrder: 8,
        },
        {
            category: 'Activation and Upgrading Help',
            question: 'I have my Activation Code. How do I enter it?',
            answer: '<p><a href="Help/Enter-Activation">Click here for instructions...</a></p>',
            sortOrder: 9,
        },
        {
            category: 'Activation and Upgrading Help',
            question: 'My Activation Code didn\'t work. What do I do now?',
            answer: '<p><a href="Help/Troubleshoot">Click here for instructions...</a></p>',
            sortOrder: 10,
        },
        {
            category: 'Activation and Upgrading Help',
            question: 'I want to purchase and activate a new license.',
            answer: '<p><a href="Help/Purchase-CC">Click here for instructions to purchase using a Credit Card...</a></p><p><a href="Help/PlumbingCAD/Purchase-Prepaid">Click here for instructions to purchase using a Prepaid Code...</a></p>',
            sortOrder: 11,
        },
        {
            category: 'Activation and Upgrading Help',
            question: 'How do I renew my Annual Subscription?',
            answer: '<p><a href="Help/PlumbingCAD/Renew-CC">Click here for instructions to renew your subscription using a Credit Card...</a></p><p><a href="Help/PlumbingCAD/Renew-Prepaid">Click here for instructions to renew your subscription using a Prepaid Code...</a></p>',
            sortOrder: 12,
        },
        {
            category: 'Activation and Upgrading Help',
            question: 'How do I upgrade to the latest software version?',
            answer: '<p><a href="Help/Upgrade">If your subscription is active, click here for instructions...</a></p><p><a href="Help/PlumbingCAD/Renew-CC">If your subscription has expired, click here for instructions on renewal...</a></p>',
            sortOrder: 13,
        },
        {
            category: 'Activation and Upgrading Help',
            question: 'I want to activate the software on a second computer for my personal use.',
            answer: '<p><a href="Help/Secondary-Activation">Click here for instructions...</a></p>',
            sortOrder: 14,
        },
        {
            category: 'Activation and Upgrading Help',
            question: 'I have a new computer. How do I transfer my activation?',
            answer: '<p><a href="Help/Reactivate">Click here for instructions...</a></p>',
            sortOrder: 15,
        },
        {
            category: 'Activation and Upgrading Help',
            question: 'Can I transfer one of our licenses to a new/different employee?',
            answer: '<p>Yes you can. You will need to <a href="../Contact">Contact Us</a> to request a transfer.</p>',
            sortOrder: 16,
        },
        {
            category: 'Features and Other Questions',
            question: 'What learning resources are available?',
            answer: '<p>To get started learning, we recommend using the video tutorial.</p>' +
                '<p><ul><a href="/Support/Tutorial?productLine=plumbingcad">www.PlumbingCAD.com/Tutorial</a></p>' +
                '<p>As well PlumbingCAD provides a comprehensive Help file. From anywhere in the program you can press F1 to open the Help file, or choose the "Help | Contents" menu. You can then browse topics or search the index for keywords.</p>',
            sortOrder: 17,
        },
        {
            category: 'Features and Other Questions',
            question: 'Can I import PDF drawings?',
            answer: '<p>Yes you can import PDF drawings or scanned drawings in JPG, PNG, or BMP formats as well as AutoCAD DWG and DXF files.</p>',
            sortOrder: 18,
        },
        {
            category: 'Features and Other Questions',
            question: 'I am getting an error. How can I send you the details?',
            answer: '<p>If a program error window appears onscreen, first complete the "Name", "Email", and "Notes" fields and then click the "Send Error Report" button. If prompted to include a copy of the project file, choose "Yes".</p>' +
                '<p>It is often helpful if you enter a brief description into the "Notes" field explaining what you were doing or attempting when the error occurred.</p>' +
                '<p>We will review the error details and then contact you.</p>',
            sortOrder: 19,
        },
    ],

}
